// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell-main {
  --app-shell-top-offset: 0px;
  display: block;
  width: 100%;
  min-height: 100dvh;
  padding-left: 220px;
  box-sizing: border-box;
  transition: padding 0.3s ease;
  transition: padding var(--transition-fast, 0.3s) ease;
}

@media (max-width: 900px) {
  .app-shell-main {
    --app-shell-top-offset: calc(64px + env(safe-area-inset-top, 0px));
    padding-top: var(--app-shell-top-offset);
    padding-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Layout.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,6BAAqD;EAArD,qDAAqD;AACvD;;AAEA;EACE;IACE,kEAAkE;IAClE,wCAAwC;IACxC,eAAe;EACjB;AACF","sourcesContent":[".app-shell-main {\n  --app-shell-top-offset: 0px;\n  display: block;\n  width: 100%;\n  min-height: 100dvh;\n  padding-left: 220px;\n  box-sizing: border-box;\n  transition: padding var(--transition-fast, 0.3s) ease;\n}\n\n@media (max-width: 900px) {\n  .app-shell-main {\n    --app-shell-top-offset: calc(64px + env(safe-area-inset-top, 0px));\n    padding-top: var(--app-shell-top-offset);\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
